var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mb-2",attrs:{"block":"","color":"warning","text":"","disabled":_vm.disabled,"small":""},on:{"click":_vm.handleClick}},[_vm._v(" Validar telefono ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }